// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__Q-57w","dialog":"styles_dialog__1V8t-","header":"styles_header__9ihIA","body":"styles_body__3Sxr0","buttonContainer":"styles_buttonContainer__3mXrU"};